import React from 'react';
import HomeLayout from '../../components/Layout/HomeLayout';
import Safety from './Safety';

const title = 'Seguro Eslipin';

export default async function action() {
  return {
    title,
    description: 'Seguro Eslipin - Tu tranquilidad también viaja con nosotros',
    component: (
      <HomeLayout whiteHeader>
        <Safety />
      </HomeLayout>
    ),
  };
}
